/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateCustomFieldDefinitionMutationResponse,
  UpdateCustomFieldDefinitionPathParams,
} from "../types/UpdateCustomFieldDefinition.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateCustomFieldDefinitionMutationKey = () =>
  [{ url: "/v1/custom-field/definition/:id" }] as const

export type UpdateCustomFieldDefinitionMutationKey = ReturnType<
  typeof updateCustomFieldDefinitionMutationKey
>

/**
 * @summary Update a custom field definition
 * {@link /v1/custom-field/definition/:id}
 */
export async function updateCustomFieldDefinition(
  id: UpdateCustomFieldDefinitionPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    UpdateCustomFieldDefinitionMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "PUT",
    url: `/v1/custom-field/definition/${id}`,
    ...requestConfig,
  })
  return res
}

export function updateCustomFieldDefinitionMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = updateCustomFieldDefinitionMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateCustomFieldDefinitionMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateCustomFieldDefinitionPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return updateCustomFieldDefinition(id, config)
    },
  })
}

/**
 * @summary Update a custom field definition
 * {@link /v1/custom-field/definition/:id}
 */
export function useUpdateCustomFieldDefinition<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateCustomFieldDefinitionMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: UpdateCustomFieldDefinitionPathParams["id"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateCustomFieldDefinitionMutationKey()

  const baseOptions = updateCustomFieldDefinitionMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateCustomFieldDefinitionMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateCustomFieldDefinitionPathParams["id"] },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateCustomFieldDefinitionMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateCustomFieldDefinitionPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateCustomFieldDefinitionMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateCustomFieldDefinitionPathParams["id"] },
    TContext
  >
}
